import Icon from "@components/Atoms/Icon";
import type { DiffLineType } from "@ext/git/core/Diff/logic/model/DiffLine";
import { tv } from "tailwind-variants";

const marker = tv({
	base: "h-[inherit]",
	variants: {
		type: {
			added: "w-[3px] rounded-[2px] bg-[var(--color-status-new)]",
			modified: "w-[3px] rounded-[2px] bg-[var(--color-status-modified)]",
			breadcrumb: "w-[3px] rounded-[2px] bg-[var(--color-status-rename)]",
			deleted: "w-1 border-solid border-transparent border-l-[var(--color-status-deleted)]",
			comment: "flex items-center",
		},
	},
});

const ACCENT = "var(--color-text-accent)";

export const DiffLineMarker = ({ type, height }: { type: DiffLineType; height: number }) => {
	if (type === "comment")
		return (
			<div className={marker({ type })} style={{ height }}>
				<Icon code="message-square" size="12px" svgStyle={{ color: ACCENT, fill: ACCENT }} />
			</div>
		);

	return <div className={marker({ type })} style={type === "deleted" ? { borderWidth: height } : undefined} />;
};
